import { render, staticRenderFns } from "./ProfitCenterAdditionalFields.vue?vue&type=template&id=3a4c5f16&scoped=true&lang=pug&"
import script from "./ProfitCenterAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ProfitCenterAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitCenterAdditionalFields.vue?vue&type=style&index=0&id=3a4c5f16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c5f16",
  null
  
)

export default component.exports